import apiClient from '../apiClient';
import { UPLOAD_COMMIT_RESTAURANT_PRICE_URL } from '../apiUrl';

const uploadMasterRestaurantPriceApi = data => {
  return apiClient.post(UPLOAD_COMMIT_RESTAURANT_PRICE_URL, data);
};

export default uploadMasterRestaurantPriceApi;
